module.exports = __webpack_public_path__ + "static/media/Gilberto.5a734d36.jpg";